import { render, staticRenderFns } from "./cadastro-simples-form.vue?vue&type=template&id=4c7201eb"
import script from "./cadastro-simples-form.vue?vue&type=script&lang=js"
export * from "./cadastro-simples-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports